<script>
import { GlAlert, GlLink, GlSprintf } from '@gitlab/ui';
import { STATUS_PAGE_LINK } from '~/javascripts/constants';

export const i18n = Object.freeze({
  ZUORA_MAINTENANCE_TITLE: 'Customers Portal outage',
  ZUORA_MAINTENANCE_MESSAGE:
    'Some actions are not available at this time. For updates, check %{statusPageLinkStart}status.gitlab.com%{statusPageLinkEnd}.',
});

export default {
  name: 'ZuoraAvailabilityError',
  components: {
    GlAlert,
    GlLink,
    GlSprintf,
  },
  i18n,
  STATUS_PAGE_LINK,
};
</script>

<template>
  <gl-alert variant="danger" :dismissible="false" :title="$options.i18n.ZUORA_MAINTENANCE_TITLE">
    <gl-sprintf :message="$options.i18n.ZUORA_MAINTENANCE_MESSAGE">
      <template #statusPageLink="{ content }">
        <gl-link
          data-testid="status-page-link"
          :href="$options.STATUS_PAGE_LINK"
          target="_blank"
          class="gl-text-blue-600 gl-underline"
          >{{ content }}</gl-link
        >
      </template>
    </gl-sprintf>
  </gl-alert>
</template>
